import Spinner from '../../assets/Spinner.svg';
import './Loading.scss';

interface Props {
    loading: boolean;
}

function Loading(props: Props) {
    const { loading } = props;

    if (!loading) return null;
    return (
        <div className='loader-container'>
            <div className='loader'>
                <img src={Spinner} alt='spinner' />
            </div>
        </div>
    )
}

export default Loading;
